import type { WrittenSyllable } from "./copy-html.js";
import {
  capitalised,
  isCapitalised,
  markPinyinWord,
  type ParsedPiece,
} from "./syllable-text.js";

/**
 * A parsed text as syllables that can each carry a colour.
 *
 * Syllable by syllable rather than word by word, which is the whole reason
 * this exists: every other output panel writes a word as one string, and the
 * pinyin one has to put a colour on each syllable inside it. The 隔音符号 goes
 * on the syllable that takes it, and a word written with a capital keeps it.
 */
export function writtenPinyin(
  pieces: readonly ParsedPiece[],
): readonly WrittenSyllable[] {
  return pieces.flatMap((piece) => {
    const syllables = piece.syllables;
    if (syllables === undefined) {
      return [{ text: piece.text, tone: undefined }];
    }

    const isCapital = isCapitalised(piece.text);

    return markPinyinWord(syllables, "marks").map((text, at) => ({
      text: at === 0 && isCapital ? capitalised(text) : text,
      tone: syllables[at]?.tone,
    }));
  });
}
